import moment from 'moment';
import { getData } from '@/components/report/service';
import { crudRequest } from '@/services/api';
import { computeWeight } from '@/utils/query';
import { TableQuery } from '../Filter';

// const ateRange = [
//   moment(new Date()).add(0, 'days').format('YYYY-MM-DD 12:00:00'),
//   moment(new Date()).add(1, 'days').format('YYYY-MM-DD 12:00:00')
// ]
const paramsForm = {
  endDate: moment(new Date()).add(0, 'days').format('YYYY-MM-DD'),
  scanProvinceArea: undefined, //{name: '浙江经营本部', code: 15}, // 营运区
  scanSite: undefined, // 分拨  哈尔滨分拨中心
  sendSite: undefined, // 下沙工业一区S
  sendType: 'receiveSite', // 选择类型
};

export default {
  namespace: 'outletsdepartStorehouseSR',
  state: {
    filter: { ...paramsForm },
    defualtDateFormat: 'YYYY-MM-DD',

    actualDepartureCarsItem: [], // 已发出 tms
    volumeItem: [], // 线路运力

    tableItem: [],

    provinceData: [], //营运区接口

    page: 1,
    pageSize: 20,
  },
  effects: {
    *resetSearch(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          filter: { ...paramsForm },
        },
      });
    },
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
    },
    *getData(_, { call, put, select }) {
      crudRequest('/api/route/outletsdepartStorehouse/search'); // 日志

      let query = yield select(({ outletsdepartStorehouseSR }) => {
        const {
          scanProvinceArea,
          scanSite,
          sendSite,
          sendType,
          endDate,
        } = outletsdepartStorehouseSR.filter;
        return {
          scanProvinceArea: scanProvinceArea,
          scanSite: scanSite,
          sendSite: sendSite,
          sendType: sendType,
          endDate: moment(endDate).format(outletsdepartStorehouseSR.defualtDateFormat),
        };
      });
      const params = {
        scanProvinceArea: query.scanProvinceArea ? query.scanProvinceArea.name : '',
        scanSite: query.scanSite ? query.scanSite.name : '',
        startDate: query.endDate + ' 00:00:00',
        endDate: query.endDate + ' 23:59:59',
      };
      if (query.sendSite) {
        params[query.sendType] = query.sendSite.name;
      }
      const filter = TableQuery(params);
      const data = yield call(getData, filter[0]);
      const tableData = data || [];
      if (tableData.length > 0) {
        const destinationSites = tableData.map((item) => item.destinationSite);
        // tableData.forEach()
        // console.table(destinationSites)
        const filter2 = TableQuery({
          scanSite: query.centerFilter,
          startDate: query.endDate + ' 00:00:00',
          endDate: query.endDate + ' 23:59:59',
          destinationSites: destinationSites,
        });
        // 一派留仓
        const results1 = [];
        for (let i = 0; i < filter2[1].length; i++) {
          const d = yield call(getData, filter2[1][i]);
          results1.push(d || []);
        }
        // 二派留仓
        const results2 = [];
        for (let i = 0; i < filter2[2].length; i++) {
          const d = yield call(getData, filter2[2][i]);
          results2.push(d || []);
        }

        tableData.forEach((item, index) => {
          item.index = index;
          item.time = moment(item.time).utc().format('YYYY-MM-DD');
          // 一派
          results1.forEach((item2, index2) => {
            const obj = item2.find((item3) => {
              return (
                item3.destinationSite === item.destinationSite && item3.scanSite === item.scanSite
              );
            });
            if (index2 === 0) {
              item.leaveTime1 = obj ? moment(obj.leaveTime).format('HH:mm') : '--';
            }
            item[`goodsWeight${index2}`] = obj ? computeWeight(obj.goodsWeight) : 0;
            item[`ticket${index2}`] = obj ? Math.abs(obj.ticket || 0) : 0;
            item[`piece${index2}`] = obj ? Math.abs(obj.piece || 0) : 0;
          });
          // 二派
          results2.forEach((item2, index2) => {
            const obj = item2.find(
              (item3) =>
                item3.destinationSite === item.destinationSite && item3.scanSite === item.scanSite,
            );
            if (index2 === 0) {
              item.leaveTime2 = obj ? moment(obj.leaveTime).format('HH:mm') : '--';
            }
            item[`twogoodsWeight${index2}`] = obj ? computeWeight(obj.goodsWeight) : 0;
            item[`twoticket${index2}`] = obj ? Math.abs(obj.ticket || 0) : 0;
            item[`twopiece${index2}`] = obj ? Math.abs(obj.piece || 0) : 0;
          });
        });
      }
      // const arr = tableData.filter(item => item.destinationSite === '宁波宁海')
      //   console.log('arr', arr)
      yield put({
        type: 'update',
        payload: {
          tableItem: tableData,
        },
      });

      yield put({
        type: 'getClockList',
      });
    },
    *getClockList(_, { call, put, select }) {
      let tableItem = yield select(({ outletsdepartStorehouseSR }) => {
        return outletsdepartStorehouseSR.tableItem;
      });

      let requestItem = tableItem.filter(
        (item) => item.leaveTime1 === '--' || item.leaveTime2 === '--',
      );
      if (requestItem?.length === 0) {
        return;
      } else {
        const result = yield crudRequest(
          '/api/search/clockList?clockType=接货离港',
          requestItem?.map((item) => item.destinationSite),
        );
        let data = result.data;

        // 遍历 requestItem 数组中的每个元素
        for (const item of requestItem) {
          // 从 data 对象中获取 item 的目的地站点相关信息
          let clocks = data?.[item?.destinationSite];

          if (!clocks) {
            continue;
          }
          // 如果 item 的 leaveTime1 为 '--'，则进行以下操作
          if (item.leaveTime1 === '--') {
            // 在 clocks 数组中查找符合条件的 clock 对象（clockSiteName 等于 item 的 scanSite，且 lineNum 等于 1）
            // 如果找到了符合条件的 clock 对象，则将 clockTime 赋值给 item 的 leaveTime1，否则保持为 '--'
            let clockTime = clocks.find(
              (clock) => clock.clockSiteName === item.scanSite && clock.lineNum === 1,
            )?.clockTime;
            if (clockTime) {
              item.leaveTime1 = moment(clockTime, 'HH:mm:ss').format('HH:mm');
            }
          }

          // 如果 item 的 leaveTime2 为 '--'，则进行以下操作
          if (item.leaveTime2 === '--') {
            // 在 clocks 数组中查找符合条件的 clock 对象（clockSiteName 等于 item 的 scanSite，且 lineNum 等于 2）
            // 如果找到了符合条件的 clock 对象，则将 clockTime 赋值给 item 的 leaveTime2，否则保持为 '--'
            let clockTime = clocks.find(
              (clock) => clock.clockSiteName === item.scanSite && clock.lineNum === 2,
            )?.clockTime;
            if (clockTime) {
              item.leaveTime2 = moment(clockTime, 'HH:mm:ss').format('HH:mm');
            }
          }
        }
      }

      // yield put({
      //   type: 'update',
      //   payload: {
      //     tableItem,
      //   },
      // });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, filter: { ...state.filter, ...payload } };
    },
  },
};
